import { ButtonProps } from "@mui/material";
import React from "react";
import * as S from "./styles";

const LinkButton = (props: ButtonProps) => {
  return <S.Button {...props}>{props.children}</S.Button>;
};

export default LinkButton;
